import { endOfDay, isAfter, isBefore } from "date-fns";
import { ILotes } from "interfaces/lotes";
import { formatCurrency } from "./utils";

export function getValueLote(lotes: ILotes[], tag: string) {
  const loteCurrent = lotes.find((lote) =>
    checkLoteCurrent({
      dataInicioLote: lote.dataInicio,
      dataFimLote: lote.dataFinal,
    })
  );

  // Buscar o valor do lotes corrente, caso não encontrar pegar o primeiro lote
  const valorLoteTag = loteCurrent
    ? loteCurrent.valoresTags
    : lotes[0].valoresTags;

  // Se não encontrar o lote, retornar TAG e valor 0
  if (valorLoteTag.length === 0) return `${tag} - R$ 0.00`;

  // Buscar o valor da tag
  const valorTag = valorLoteTag.find((item) => item.tag.tipo === tag);

  if (!valorTag) {
    return `${tag} - INEXISTENTE`;
  }

  return `${tag} - ${formatCurrency(valorTag.valor)}`;
}

interface checkLoteProps {
  dataInicioLote: string;
  dataFimLote: string;
}

function checkLoteCurrent({ dataInicioLote, dataFimLote }: checkLoteProps) {
  const today = endOfDay(new Date());

  // const today = formatISO(new Date()).slice(0, 19).concat(".000Z");

  const startLote = dataInicioLote.slice(0, 10).concat(`T00:00:59.000Z`);
  const endLote = dataFimLote.slice(0, 10).concat(`T23:59:59.000Z`);

  return isAfter(today, startLote) && isBefore(today, endLote);
}
